
import React, { useEffect } from "react";
import { Box } from "@mui/material";
import MyAccount from "./MyAccount";
import HomeScreenImg from "@/assets/earth.jpg";

function MyProfile() {
  

  return (
    <Box  sx={{
        background: `linear-gradient(89.41deg, #1B1C2D 7.81%, rgba(27, 28, 45, 0) 38.09%), linear-gradient(1.53deg, #1B1C2D 13.32%, rgba(27, 28, 45, 0) 50.41%), linear-gradient(46.49deg, #1B1C2D 14.7%, rgba(27, 28, 45, 0) 43.39%), url(${HomeScreenImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        minHeight: "100%",
        backgroundAttachment: "fixed",
        backgroundPosition: "center",
        padding: {
          xs: "10px 0",
          lg: "100px 0px 20px",
        },
      }}>
        <Box
        sx={{
          maxWidth: "95%",
          margin: "0 auto",
          
        }}
      > <MyAccount /></Box>
     
    </Box>
  );
}

export default MyProfile;
